import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { FuncionarioPesquisa } from '@app/models/funcionario-pesquisa';
import { FuncionarioPesquisaFiltros } from '@app/models/funcionario-pesquisa-filtros';
import { Paginacao } from '@app/models/util/paginacao';
import { FuncionarioService } from '@app/services/funcionario.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PlanoControleService } from '@app/services/plano-controle.service';

@Component({
  selector: 'app-funcionarios-lista',
  templateUrl: 'funcionarios-lista.component.html',
})
export class FuncionariosListaComponent implements OnInit {

  loading = true;
  lstFuncionario: FuncionarioPesquisa[];
  pesquisa = new FuncionarioPesquisaFiltros();
  paginacao: Paginacao = new Paginacao();
  bsModalRef: BsModalRef;
  podeEditarCliente = false;
  checked: string;

  percentualUtilizadoPlano: number = 0;

  constructor(
    private router: Router,
    private funcionarioService: FuncionarioService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private planoControleService: PlanoControleService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
    this.pesquisa.ativo = 'A';

  }

  ngOnInit() {
    this.planoControleService.obterControle().subscribe(data => this._calculaPlanoUso(data));
    this.obterTodos(this.pesquisa, 1);
  }

  private _calculaPlanoUso(dados) {
    if (dados.LimiteUsuarios === 0)
      return;
    this.percentualUtilizadoPlano = dados.UsuariosUtilizados / dados.LimiteUsuarios * 100;
  }

  pesquisar() {
    this.obterTodos(this.pesquisa, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(pesquisa: FuncionarioPesquisaFiltros, pagina: number) {
    this.funcionarioService.obterLista(pesquisa, pagina)
      .toPromise().then(data => {
        this.loading = false;
        this.lstFuncionario = data.Dados,
          this.paginacao.totalDeItens = data.Total;
      },
        erro => {
          this.loading = false;
          this.toastr.warning("Realize a pesquisa novamente.")
        });
  }

  deletar(funcionarioPesquisa: FuncionarioPesquisa) {
    const nome = funcionarioPesquisa.NomeFantasia && funcionarioPesquisa.NomeFantasia != '' ? funcionarioPesquisa.NomeFantasia : funcionarioPesquisa.RazaoSocial;
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja deletar o funcionário:' + funcionarioPesquisa.Id + ' - ' + nome;
    this.bsModalRef.content.confirmar = () => {
      this.funcionarioService.deletarPorId(funcionarioPesquisa.Id).toPromise().then(
        () => {
          this.toastr.success('Funcionário Deletado com sucesso!');
          this.obterTodos(this.pesquisa, 1);
          this.paginacao.paginaAtual = 1;
        },
        (data) => {
          this.toastr.error(data.error.errors[0]);
        }
      );
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.pesquisa, event.page);
  }
}
